// extracted by css-extract-rspack-plugin
export default {"content":"TErf76ROVdgAmok8","icon":"FUkfZ1mT0KIf6GYb","text":"qIXAwIKgGQSuHe7j"};